import React from 'react';
import './ArticleHeading.scss';

export const ArticleHeading = ({ node }) => {
    return (
        <div
            className={`article-heading ${
                node?.listicleItem ? `listicle` : ``
            }`}
            id={node?.listicleItem ? node?.listicleItem?.id : undefined}
        >
            {node?.listicleItem && (
                <div className="number">{node?.listicleItem?.number}</div>
            )}
            <div>
                <h2>{node?.field_heading}</h2>
                <p>{node?.field_subtitle}</p>
            </div>
        </div>
    );
};
